import { FC, useCallback, useEffect, useMemo } from 'react';
import { Link, useSnackbar } from '@robocorp/components';
import { useLocalStorage } from '~/hooks';
import { useBannersQuery } from './useBannersQuery';

interface ActionsProps {
  title: string;
  href: string;
  id: string;
}

const actions =
  ({ title, href }: ActionsProps) =>
  () => (
    <Link href={href} target="_blank">
      {title}
    </Link>
  );

export const Banners: FC = () => {
  const { storageValue: dismissedBanners, setStorageValue: setDismissedBanners } = useLocalStorage<
    string[]
  >({ key: 'DISMISSED_BANNER_LIST', initialValue: [], sync: true });
  const { addSnackbar } = useSnackbar();

  const { data: banners = [] } = useBannersQuery({ cacheTime: Infinity });

  const activeBanners = useMemo(
    () => banners.filter((banner) => !dismissedBanners.includes(banner.id)),
    [banners, dismissedBanners],
  );

  const onDismiss = useCallback(
    (bannerId: string) => setDismissedBanners((list) => [...list, bannerId]),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useEffect(() => {
    activeBanners.forEach((banner) => {
      addSnackbar({
        type: 'banner',
        title: banner.title,
        message: banner.content,
        illustration: banner.image ? (
          <img src={banner.image} loading="lazy" alt="survey" height={128} />
        ) : undefined,
        actions: banner.call_to_action
          ? actions({ ...banner.call_to_action, id: banner.id })
          : undefined,
        closeAction: () => onDismiss(banner.id),
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeBanners]);

  return null;
};
